import React, { useState } from "react";
import { Box, IconButton, Grow } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CloseIcon from "@mui/icons-material/Close";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";

const HelpCircle = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleOpenMenu = () => {
    setIsMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleEmail = () => {
    window.location.href = `mailto:${process.env.REACT_APP_SOPORTE_EMAIL}`;
    handleCloseMenu();
  };

  return (
    <Box sx={{ width: '100%', height: isMenuOpen ? 112 : 32, position: 'relative', overflow: 'hidden', transition: 'height 250ms ease' }}>
      <Grow in={!isMenuOpen} timeout={800}>
        <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <IconButton aria-label="Abrir opciones de soporte" onClick={handleOpenMenu}
            sx={{ height: '32px', width: '32px', color: 'white', backgroundColor: '#23577E', '&:hover': { backgroundColor: '#23577E' } }}>
            <SupervisedUserCircleIcon sx={{ height: '1em', width: '1em', fontSize: '1.25rem', color: 'white' }} />
          </IconButton>
        </Box>
      </Grow>

      <Grow in={isMenuOpen} timeout={800}>
        <Box sx={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <IconButton
              aria-label="Contactar a soporte por correo electrónico"
              sx={{
                height: '32px',
                width: '32px',
                color: '#ffffff',
                backgroundColor: '#23577E',
                '&:hover': {
                  backgroundColor: '#23577E',
                },
                '& .MuiSvgIcon-root': { fontSize: '1.25rem' },
              }}
              onClick={handleEmail}
            >
              <EmailOutlinedIcon />
            </IconButton>

            <IconButton component="a" href={`${process.env.REACT_APP_SOPORTE_TELEFONO}`}
              target="_blank" rel="noopener noreferrer" aria-label="Contactar a soporte por WhatsApp"
              sx={{
                height: '32px',
                width: '32px',
                color: '#ffffff',
                backgroundColor: '#23577E',
                '&:hover': {
                  backgroundColor: '#23577E',
                },
                '& .MuiSvgIcon-root': { fontSize: '1.25rem' },
              }}
            >
              <WhatsAppIcon />
            </IconButton>
          </Box>
          <IconButton aria-label="Cerrar opciones de soporte" onClick={handleCloseMenu}
            sx={{ height: '32px', width: '32px', color: '#ffffff', backgroundColor: '#23577E', '&:hover': { backgroundColor: '#23577E' } }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Grow>
    </Box>
  );
};

export default HelpCircle;
